export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9901.704b89e2.jpg";